import React, { useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import GalleryEditor from "components/Gallery/GalleryEditor";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

function AddGallery() {
  const [redirect, setRedirect] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    color: "success",
    message: "",
  });

  const handleSubmit = async (form) => {
    if (init() !== "success") {
      return;
    }

    setSubmitLoading(true);

    try {
      const fd = new FormData();
      fd.append("title", form.title);
      fd.append("caption", form.caption);
      fd.append("sort_order", form.sort_order);
      fd.append("status", form.status);

      if (form.image) {
        fd.append("image", form.image);
      }

      const response = await axios.post(Constants.postUrls.createGallery, fd);
      setNotification({
        open: true,
        color: "success",
        message: response?.data?.message || "Gallery item created successfully.",
      });

      setTimeout(() => {
        setRedirect(true);
      }, 1200);
    } catch (error) {
      setNotification({
        open: true,
        color: "error",
        message: error?.response?.data?.message || "Unable to create gallery item.",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  if (redirect) {
    return <Navigate to="/gallery" />;
  }

  return (
    <GalleryEditor
      title="Create Gallery Item"
      submitLabel="Create Gallery Item"
      onSubmit={handleSubmit}
      submitLoading={submitLoading}
      notification={notification.open}
      notificationColor={notification.color}
      notificationMessage={notification.message}
    />
  );
}

export default AddGallery;
